export default __webpack_public_path__ + "static/acq-category-1-66e8d867a8bf32d6e15121a687da05e2.jpg";